import BaseCollection from '@/collections/BaseCollection';

/**
 * Lab service base collection class
 */
export default class LabServiceCollection extends BaseCollection {

  constructor(){
    super();
  }

  // Route configuration
  privateRoutes() {
    let model = (new (this.model())());
    return {
      fetch: process.env.VUE_APP_LAB_REPOSITORY_URL + '/api/v1/' + model.modelName(),
    }
  }
}
